import { typesGlob } from "../types";
import { feesGlob } from "./fees";
import { productsGlob } from "./products";

const rootArea = "/businesses";

export const businessGlob = (baseArea = "") => ({
	self: `${baseArea}${rootArea}`,
	byType: (typeCode: string) => ({ 						
		read: `${baseArea}${rootArea}/${typeCode}/read`,
		create: `${baseArea}${rootArea}/${typeCode}/create`,
		update: `${baseArea}${rootArea}/${typeCode}/update`,
		types: typesGlob(`${baseArea}${rootArea}`),
		fees: feesGlob(`${baseArea}${rootArea}`),
		products: productsGlob(`${baseArea}${rootArea}`)
	})
});